import { SAVE_CLIENT_SIDE_FILTERS, CLEAR_FILTERS } from "typeConstants";

const saveClientSideFilters = clientSideFilters => ({
  type: SAVE_CLIENT_SIDE_FILTERS,
  payload: clientSideFilters
});

const clearClientSideFilters = () => ({
  type: CLEAR_FILTERS,
});

export { saveClientSideFilters, clearClientSideFilters };
